function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_217",
  "data-name": "Grupo 217",
  transform: "translate(-696 -583)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ret\\xE2ngulo_493",
  "data-name": "Ret\\xE2ngulo 493",
  transform: "translate(696 583)",
  fill: "#fff",
  stroke: "#1781a1",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  rx: 17,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 33,
  height: 33,
  rx: 16.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1425",
  "data-name": "Caminho 1425",
  d: "M297.4,1746.264V1742h-2.132v4.264H291v2.132h4.264v4.264H297.4V1748.4h4.264v-2.132Z",
  transform: "translate(416.4 -1147.6)",
  fill: "#1781a1"
}));
function SvgDesktopAddNew2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopAddNew2);
export default __webpack_public_path__ + "static/media/desktop_add_new2.f80e93d9.svg";
export { ForwardRef as ReactComponent };